export default {"src":"/_next/static/media/Candle-transaction-chart.916b66d6.svg","height":185,"width":534};